import { useEffect } from 'react';

/**
 * 進行中の処理があるあいだ、タブ / ウィンドウを閉じようとしたときに
 * ブラウザ標準の確認ダイアログを出す。
 *
 * アップロードや、その後の DB 登録のようにクライアント主導で走る処理は、
 * タブを閉じた時点で中断され、途中までしか反映されない。ユーザーには
 * 「もう終わった」ように見えるタイミングがあるため、明示的に引き止める。
 *
 * ブラウザ仕様上の制約:
 * - 表示される文言はブラウザ固定で、カスタマイズできない。
 * - そのページで一度もユーザー操作がない場合は発火しない
 *   （アップロード後は必ず操作済みなので実用上は問題にならない）。
 * - SPA 内のページ遷移は止められない（必要なら Router 側の blocker を併用する）。
 *
 * @param active true のあいだガードを有効にする
 */
const useUnloadGuard = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // 古いブラウザ向けの互換指定（Chrome / Safari は returnValue を見る）
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [active]);
};

export default useUnloadGuard;
